var map = {
	"./assets/icons/arrow-down.svg": [
		4466,
		466
	],
	"./assets/icons/arrow-right.svg": [
		1633,
		633
	],
	"./assets/icons/bell.svg": [
		1619,
		619
	],
	"./assets/icons/bin.svg": [
		9956,
		956
	],
	"./assets/icons/calendar.svg": [
		6467,
		467
	],
	"./assets/icons/close.svg": [
		3943,
		943
	],
	"./assets/icons/cross.svg": [
		9392,
		392
	],
	"./assets/icons/dropdown-arrow.svg": [
		2038,
		38
	],
	"./assets/icons/filters.svg": [
		1554,
		554
	],
	"./assets/icons/grid.svg": [
		1861,
		861
	],
	"./assets/icons/logo.svg": [
		7032,
		32
	],
	"./assets/icons/logout.svg": [
		4184,
		184
	],
	"./assets/icons/more.svg": [
		9069,
		69
	],
	"./assets/icons/pause.svg": [
		7791,
		791
	],
	"./assets/icons/pen.svg": [
		1129,
		129
	],
	"./assets/icons/play.svg": [
		2,
		2
	],
	"./assets/icons/plus.svg": [
		4608,
		608
	],
	"./assets/icons/projects.svg": [
		6218,
		218
	],
	"./assets/icons/rows.svg": [
		5909,
		909
	],
	"./assets/icons/stats.svg": [
		4350,
		350
	],
	"./assets/icons/tab.svg": [
		7631,
		631
	],
	"./assets/icons/target.svg": [
		3173,
		893
	],
	"./assets/icons/tasks.svg": [
		2582,
		582
	],
	"./assets/icons/team.svg": [
		7265,
		265
	],
	"./assets/icons/tick.svg": [
		7277,
		277
	],
	"./assets/icons/user.svg": [
		4662,
		662
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6848;
module.exports = webpackAsyncContext;